import React, { useState } from 'react';
import Select from 'components/Atom/Select';
import { Button } from 'components/Atom/Button';
import './style.css';
import { Button as ANTDButton, Form, notification } from 'antd';
const Filter = ({ filtersData, handleClose, onSearch, filterToggler }) => {
  const [filterData, setFilterData] = useState(filtersData);
  const handleOnChangeValue = (e, type) => {
    if (e === null || e === 'all') {
      setFilterData((prevState) => {
        const newState = { ...prevState };
        delete newState[type];
        return newState;
      });
    } else {
      setFilterData((pre) => ({ ...pre, [type]: e }));
    }
  };
  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || (Object.keys(filterData ?? {})?.length === 0 && Object.keys(filtersData ?? {})?.length > 0)) {
      onSearch(filterData);
      handleClose();
    } else {
      notification.warning({ message: 'At least one filter is required', placement: 'bottomRight' });
    }
  };
  const options = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Active',
      value: 'active',
    },
    {
      label: 'Inactive',
      value: 'inactive',
    },
    {
      label: 'Activation Required',
      value: 'activation_required',
    },
  ];
  const USER_ROLE_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'READ ONLY', value: 'xpay_user' },
    { label: 'ADMIN', value: 'xpay' },
    { label: 'USER MANAGEMENT', value: 'xstak-copilot-admin' },
    { label: 'REFUND', value: 'xpay_refund' },
    { label: 'DEVELOPER', value: 'xpay_developer' },
    { label: 'RESTRICTED ADMIN', value: 'xpay_restricted_admin' },
    { label: 'SUBSCRIPTION USER', value: 'xpay_subscription_user' },
    { label: 'SUBSCRIPTION MODULE ONLY', value: 'xpay_subscription_module_only' },
  ];
  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='custom-child'>
          <div>
            <Form.Item className='font-bold' label='Users Status:'>
              <Select defaultValue={filtersData?.user_status ?? options[0]} optionsValue={options} handleChange={(e) => handleOnChangeValue(e.value, 'user_status')} style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='font-bold' label='Role:'>
              <Select defaultValue={filtersData?.role ?? USER_ROLE_OPTIONS[0]} optionsValue={USER_ROLE_OPTIONS} handleChange={(e) => handleOnChangeValue(e.value, 'role')} style={{ width: '100%' }} />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button
              onClick={() => {
                handleApplyFilters();
                filterToggler();
              }}>
              Apply
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;
